import AppointmentForm from "./components/appointmentForm";
import AppointmentSummary from "./components/appointmentSummary";
import { Loading } from "../../../../../utils/loading";
import { dealershipMockData } from "./mock-data";
import { useConsultantSchedulingForm } from "../../../../../hooks/useConsultantSchedulingForm";

const Appointment = (props: any) => {

	const {
		step, setStep,
		loading,
		appointment, setAppointment, appointmentId,
		assets,
	} = useConsultantSchedulingForm(dealershipMockData);

	if (loading) return <Loading label="Carregando dados..." />;

	return step === 0 ?
		<AppointmentForm
			goToSummary={() => setStep(1)}
			form={appointment}
			setForm={setAppointment}
			assets={assets}
			appointmentId={appointmentId}
		/>
		:
		<AppointmentSummary
			goBackToForm={() => setStep(0)}
			appointment={appointment}
			appointmentId={appointmentId}
		/>
};

export default Appointment;
